import { v1 as uuid } from 'uuid'

import { cannot } from '@/app/helpers'
import { CampaignTemplateType, OnRetriesExhausted } from '@/app/module/campaigns/types'

export const getDefaultFailureAction = (campaignType: CampaignTemplateType): OnRetriesExhausted => {
  switch (campaignType) {
    case CampaignTemplateType.CATI:
    case CampaignTemplateType.Drip:
    case CampaignTemplateType.Reminder:
    case CampaignTemplateType.SMSBlast:
    case CampaignTemplateType.Chatbot:
      return {
        actions: [],
      }

    case CampaignTemplateType.SMSSurvey:
    case CampaignTemplateType.WhatsAppSurvey: {
      return {
        actions: [
          {
            id: uuid(),
            finishFlow: {},
          },
        ],
      }
    }

    case CampaignTemplateType.VoiceBlast:
    case CampaignTemplateType.VoiceSurvey: {
      return {
        actions: [
          {
            id: uuid(),
            hangup: {},
          },
        ],
      }
    }

    default:
      return cannot(campaignType)
  }
}
